import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { BOX_IMG, CHECKOUT_URL } from './constants';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const units = [{
    value: timeLeft.hours,
    label: 'ORE'
  }, {
    value: timeLeft.minutes,
    label: 'MIN'
  }, {
    value: timeLeft.seconds,
    label: 'SEC'
  }];
  return <section id="pricing" className="py-8 px-4 sm:px-6 bg-white border-y-4 border-gold/30 scroll-mt-2" data-id="element-109" data-mp="32k2id6jj5x42">
      <div className="text-center mb-4" data-id="element-110" data-mp="37i42lusp02h4">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-cta uppercase tracking-widest mb-1" data-id="element-111" data-mp="2suixxwg65v73">
          Offerta Speciale — Sistema Completo 6-in-1
        </p>
        <h2 className="text-lg sm:text-2xl font-heading font-extrabold text-petrol leading-tight mb-3" data-id="element-112" data-mp="2xrsya753jr9p">
          Accedi subito al sistema completo e rivoluziona il modo in cui prepari
          le tue lezioni.
        </h2>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-113" data-mp="29voismcsmsqe">
          <img src={BOX_IMG} alt="SENIOR FITNESS COACH PRO — Sistema Completo 6-in-1" className="w-full max-w-[220px] mx-auto object-contain drop-shadow-lg hover:scale-[1.02] transition-transform duration-300" data-id="element-114" data-mp="2ev9ttv58mrjh" />
        </a>
      </div>

      <div className="max-w-md mx-auto bg-cream border-2 border-gold rounded-xl p-4 sm:p-6 text-center mb-4 shadow-lg" data-id="element-115" data-mp="bn94ykefyvb3">
        <p className="font-heading font-bold text-petrol text-xs sm:text-sm uppercase tracking-wide mb-3 leading-snug" data-id="element-116" data-mp="6ljtx4r7yhn0">
          🏋️ SENIOR FITNESS COACH PRO™ — Sistema Completo 6-in-1 per Allenatori
          di Fitness Senior
        </p>

        <p className="text-sm font-semibold text-warmgray mb-1" data-id="element-117" data-mp="ucph64zhoc7c">
          Prezzo di Listino: <span className="line-through" data-id="element-118" data-mp="uejv2zccf41x">97€</span>
        </p>
        <p className="text-xs sm:text-sm font-heading font-bold text-cta mb-1 uppercase tracking-wide" data-id="element-119" data-mp="pexfwkcyfdqh">
          🔥 72% DI SCONTO — Offerta di Lancio a Tempo Limitato
        </p>
        <p className="text-4xl sm:text-5xl font-heading font-extrabold text-petrol leading-none mb-1" data-id="element-120" data-mp="gm3xie27ny8e">
          Oggi Solo: 27€
        </p>
        <p className="text-[11px] font-semibold text-warmgray uppercase tracking-widest mb-4" data-id="element-121" data-mp="1d4i3xhnyt16m">
          Pagamento sicuro nella tua valuta.
        </p>

        <div className="bg-white border border-gold/40 rounded-lg p-3 mb-4" data-id="element-122" data-mp="2r006uxn91anl">
          <p className="text-[11px] sm:text-xs font-heading font-bold text-cta mb-2 uppercase tracking-wide" data-id="element-123" data-mp="2vy1orf8xv3xh">
            ⏳ Questa offerta terminerà allo scadere del conto alla rovescia.
          </p>
          <div className="flex justify-center gap-2" data-id="element-124" data-mp="34yri8caq8i81">
            {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-125" data-mp="39y4690dc3vc7" data-mpi={i}>
                {i > 0 && <span className="text-xl font-bold text-petrol" data-id="element-126" data-mp="39vzyg7cbec6n">:</span>}
                <div className="text-center" data-id="element-127" data-mp="3ev2ux3e8ba30">
                  <div className="bg-petrol text-white text-xl font-heading font-bold px-2.5 py-1.5 rounded min-w-[48px] leading-none" data-id="element-128" data-mp="3jndycg86he0b">
                    {String(unit.value).padStart(2, '0')}
                  </div>
                  <p className="text-[9px] font-bold text-petrol/70 mt-1 tracking-widest" data-id="element-129" data-mp="3spn7p2rpn1c4">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>
        </div>

        <CTAButton data-id="element-130" data-mp="3jyvdzmk33zyc">🚀 SÌ! VOGLIO SENIOR FITNESS COACH PRO™</CTAButton>
      </div>

      <TrustRow data-id="element-131" data-mp="3f1le1cz2k5w9" />
    </section>;
}